import { createApp } from 'vue';

import '@/style.css';
import 'element-plus/theme-chalk/dark/css-vars.css';
import '@/assets/styles/site.css';
import '@/assets/styles/tailwind.css';
import '@/assets/styles/iconfont.css';
import '@/assets/styles/ligth.css';
import '@/assets/styles/battery.css';
// import '@/assets/styles/dark.css';
import '@/assets/styles/fonts.css';
// 引入和风天气图标
import 'qweather-icons/font/qweather-icons.css';
// import './utils/rem';

import 'element-closest-polyfill';

import * as Sentry from '@sentry/vue';
import App from '@/App.vue';
import router from '@/routes';
import { setupStore } from '@/store';

import loadingDirective from '@/directive/loading';
import VueLazyload from 'vue-lazyload';
// import './assets/styles/font-weight.css'; // 添加字体加粗样式

const app = createApp(App);
/**
 * echarts图表响应式
 * @param {* 图表DOM} ref;
 */
app.config.globalProperties.$echartsResize = (ref) => {
  window.addEventListener('resize', () => {
    ref.resize();
  });
};
// eslint-disable-next-line no-unused-expressions, no-undef
// process.env.NODE_ENV === 'production' && Sentry.init({
//   app,
//   dsn: 'http://a5305b7c51784d5f9c24a6291dd251bb@172.18.44.10:9000/2',
//   integrations: [
//     new Sentry.BrowserTracing({
//     //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
//     }),
//     new Sentry.Replay(),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 0.1,
//   // If the entire session is not sampled, use the below sample rate to sample
//   // sessions when an error occurs.
//   replaysOnErrorSampleRate: 1.0,
// });

setupStore(app);
app.use(router);
app.use(VueLazyload);
app.directive('YniiLoading', loadingDirective);
app.mount('#app');
